import { Variant } from "~/models/Content/ContentProducts"
import {
  EcommercePriceVariantName,
  EcommerceProduct,
} from "~/types/ecommerce/product"
export const getProductVariantPrice = (product?: Variant) => {
  if (product) {
    const price = product?.variants[0]?.eCommerce?.price
    return typeof price === "number" && price >= 0 ? price : undefined
  }
  return undefined
}

export const getProductVariantPriceLabel = (product?: Variant) => {
  const price = getProductVariantPrice(product)
  if (price !== undefined) {
    if (typeof price === "number" && price > 0) {
      return " Pris "
    }
    return " Gratis "
  }
  return ""
}

export function getEcommerceProductPrice(
  catalogueData: EcommerceProduct[],
  productEan: string,
): number | undefined {
  if (!catalogueData || catalogueData.length === 0) return undefined

  const product = catalogueData.find(p =>
    p.variants.some(v => v.ean === productEan),
  )
  if (!product) return undefined

  const variant = product.variants.find(v => v.ean === productEan)
  if (!variant) return undefined

  const priceVariants: EcommercePriceVariantName[] = [
    "Consumer discount",
    "Consumer price",
    "Discount",
    "Price",
  ]

  for (const variantName of priceVariants) {
    const price = variant.priceVariants.find(
      pv => pv.name === variantName,
    )?.price
    if (price !== undefined) return price
  }

  return undefined
}
